import React, { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
import { NavConfig } from '../../data/constants/nav';

const UtilitiesMain = lazy(() => import('../utilities/UtilitiesMain'));
const AffiliateList = lazy(
  () => import('../utilities/affiliates/AffiliateList')
);
const SocialMediaMonitoring = lazy(
  () => import('../utilities/social-media/SocialMediaMonitoring')
);
const FileAttachments = lazy(
  () => import('../utilities/file-attachments/FileAttachments')
);

export default [
  {
    id: NavConfig.groupConfigs.UTILITIES.id,
    path: NavConfig.groupConfigs.UTILITIES.to,
    element: (
      <UtilitiesMain>
        <Suspense>
          <Outlet />
        </Suspense>
      </UtilitiesMain>
    ),
    children: [
      {
        id: NavConfig.linkConfigs.UTIL_AFFILIATES.id,
        path: NavConfig.linkConfigs.UTIL_AFFILIATES.to,
        element: <AffiliateList />,
      },
      {
        id: NavConfig.linkConfigs.UTIL_SOCIAL_MEDIA.id,
        path: NavConfig.linkConfigs.UTIL_SOCIAL_MEDIA.to,
        element: <SocialMediaMonitoring />,
      },
      {
        id: NavConfig.linkConfigs.UTIL_FILE_ATTACHMENTS.id,
        path: NavConfig.linkConfigs.UTIL_FILE_ATTACHMENTS.to,
        element: <FileAttachments />,
      },
    ],
  },
];
